import { render, staticRenderFns } from "./NotApplicable.vue?vue&type=template&id=0ac1ae1d&scoped=true"
import script from "./NotApplicable.vue?vue&type=script&lang=js"
export * from "./NotApplicable.vue?vue&type=script&lang=js"
import style0 from "./NotApplicable.vue?vue&type=style&index=0&id=0ac1ae1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac1ae1d",
  null
  
)

export default component.exports